<fieldset>
    @if(label || infoText || helpUrl) {
    <label [raskRequired]="required">
        {{label}}
        @if (infoText) {
        <rask-info>{{infoText}}</rask-info>
        }
        @if (helpUrl) {
        <rask-helpicon [helpUrl]="helpUrl"></rask-helpicon>
        }

    </label>
    }
    @for (button of buttons; track button) {
    <rask-radiobutton
        [label]="button.value"
        [negative]="negative"
        [attr.negative]="negative ? '' : null"
        [disabled]="disabled"
        [attr.disabled]="disabled ? '' : null"
        [key]="button.key"
        (checkedChange)="changed($event)"
        [checked]='value === button.key'
        [small]="small"
        [ngClass]="{'vertical': verticalLayout, 'small': small}"
        [onBeforeChange]="onBeforeChange">
    </rask-radiobutton>
    }
    @if (rule) {
    <rask-validation-message [rule]="rule"></rask-validation-message>
    }
</fieldset>